module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e883831"
    }
  }, [_c('b', [_vm._v("HUMMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e884331"
    }
  }, [_c('b', [_c('i', [_vm._v("Middle Eastern dips, such as hummus, once seemed exotic, but now they’re familiar old friends. Tahini is readily available at health food stores and supermarkets.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e885631"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes plus chilling")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e886231"
    }
  }, [_vm._v("4 garlic cloves, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e886531"
    }
  }, [_vm._v("1 large lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e886831"
    }
  }, [_vm._v("1 can (15 to 19 ounces) garbanzo beans, "), _c('br'), _vm._v(" rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e887431"
    }
  }, [_vm._v("2 tablespoons tahini (sesame seed paste)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e887731"
    }
  }, [_vm._v("3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e888131"
    }
  }, [_vm._v("2 tablespoons water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e888431"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e889331"
    }
  }, [_vm._v("⅛ teaspoon ground red pepper (cayenne)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e890331"
    }
  }, [_vm._v("½ teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e891231"
    }
  }, [_vm._v("2 tablespoons chopped fresh cilantro (optional) "), _c('br'), _vm._v(" pita bread wedges "), _c('br'), _vm._v(" olives")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e892431"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 1-quart saucepan, heat "), _c('i', [_vm._v("2 cups water ")]), _vm._v("to boiling over high heat. Add garlic and cook 3 minutes to blanch; drain.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e894231"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" From lemon, grate 1 teaspoon peel and squeeze 3 tablespoons juice. In food processor with knife blade attached, combine beans, tahini, garlic, lemon peel and juice, oil, water, salt, and ground red pepper. Puree until smooth. Transfer to platter; cover and refrigerate up to 4 hours. To serve, sprinkle with paprika and cilantro, if using. Serve with pita bread wedges and olives. Makes 2 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e897331"
    }
  }, [_vm._v("Each tablespoon: About 28 calories, 1g protein, 2g carbohydrate, 2g total fat (0g saturated), 0mg cholesterol, 54mg sodium.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e898331"
    }
  }, [_c('b', [_vm._v("MEZE")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "l.jpg",
      "src": "Images/l.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e899031"
    }
  }, [_vm._v("Meze, little savory dishes to be nibbled before a meal or with drinks, are a tradition in Greece, Turkey, and the Middle East. Try any of the following with pita or French bread, along with feta cheese chunks, olives, radishes, sliced cucumbers, or tomato wedges: Roasted Red Pepper Dip, Tzatziki, or Hummus.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e9419f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c13_r1.vue
// module id = 105
// module chunks = 0